// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AccordionController from './accordion_controller.js'
import CollapseController from './collapse_controller.js';
import CopyToClipboardController from './copy_to_clipboard_controller.js';
import DynamicUboController from './dynamic_ubo_controller.js';
import DirectUploadFormController from './direct_upload_form_controller.js';
import DirectUploadInputController from './direct_upload_input_controller.js';
import FileBackSelectionMenuController from './file_back_selection_menu_controller.js'
import FlashController from './flash_controller.js';
import FormController from './form_controller.js';
import FormValidationController from './form_validation_controller.js';
import HelloController from './hello_controller.js';
import LemonwayIframeController from './lemonway_iframe_controller.js';
import MobileSidebarController from './mobile_sidebar_controller.js';
import ModalController from './modal_controller.js'
import PopperController from './popper_controller.js';
import ProfileSwitcherController from './profile_switcher_controller.js';
import SignController from './sign_controller.js';
import ScrollspyController from './scrollspy_controller.js'
import Users__Profiles__KycDocumentFormController from './users/profiles/kyc_document_form_controller.js';
import Users__Profiles__RecoveryFeeCollections__SubscriptionFormController
  from './users/profiles/recovery_fee_collections/subscription_form_controller.js';
import NestedFormDragController from './nested_form_drag_controller.js';
import RedactorController from './redactor_controller.js';
import UniversignController from './universign_controller.js';
import PhoneInputController from './phone_input_controller.js';
import SearchFormController from './search_form_controller.js';
import PasswordVisibilityController from './password_visibility_controller.js';
import VerificationCodeController from './verification_code_controller.js';

application.register('accordion', AccordionController)
application.register('collapse', CollapseController);
application.register('copy-to-clipboard', CopyToClipboardController);
application.register('dynamic-ubo', DynamicUboController);
application.register('direct-upload-form', DirectUploadFormController);
application.register('direct-upload-input', DirectUploadInputController);
application.register('file-back-selection-menu', FileBackSelectionMenuController)
application.register('flash', FlashController);
application.register('form', FormController);
application.register('form-validation', FormValidationController);
application.register('hello', HelloController);
application.register('lemonway-iframe', LemonwayIframeController);
application.register('mobile-sidebar', MobileSidebarController);
application.register('modal', ModalController)
application.register('popper', PopperController);
application.register('profile-switcher', ProfileSwitcherController);
application.register('sign', SignController);
application.register('scrollspy', ScrollspyController)
application.register(
  'users--profiles--kyc-document-form',
  Users__Profiles__KycDocumentFormController
);
application.register(
  'users--profiles--recovery-fee-collections-subscription-form',
  Users__Profiles__RecoveryFeeCollections__SubscriptionFormController
);
application.register('search-form', SearchFormController);
application.register('nested-form-drag', NestedFormDragController);
application.register('redactor', RedactorController);
application.register('universign', UniversignController);
application.register('phone-input', PhoneInputController);
application.register('password-visibility', PasswordVisibilityController);
application.register('verification-code', VerificationCodeController);
